export default __webpack_public_path__ + "static/media/customer-support-illustration.7164659e.svg";